<template>
  <div>
    
    <el-button class="settings-toggle relative z-10 flex mb-3" @click="navActive=!navActive" size="mini">
      <ContextMenuHeaderIcon type="info" plain class="inline-block context-menu-header-hover text-xs"/>
      <span class="inline-block self-center">SETTINGS</span>
    </el-button>
    
    <div class="settings-wrap block md:flex md:space-x-6 relative">
      
    <div class="settings-menu-wrap self-baseline" :class="navActive ? 'active':''" v-show="navActive || !isMobile">
      <div class="absolute right-0 top-1 z-10 text-gray-500 md:hidden" @click="navActive=!navActive">
        <i class="uil uil-multiply text-2xl"></i>
      </div>
      <h5 class="text-xs p-3 md:hidden">COMPANY SETTINGS MENU</h5>
      <el-menu
        data-cy="setting-ops"
        active-text-color="#000000"
        class="h-full rounded-tl-lg rounded-bl-lg settings-menu w-48"
        :default-active="activePath"
        :router="true"
        @select="onMenuSelect"
        >
        <el-menu-item index="/settings/account-details" v-if="permissions['permissionFullAccess']">
          <i class="uil uil-diary-alt text-xl pr-1"></i>
          <span>Account Details</span>
        </el-menu-item>
        <el-menu-item index="/settings/invoices" v-if="permissions['permissionFullAccess']">
          <i class="uil uil-file-alt text-xl pr-1"></i>
          <span>Invoices</span>
        </el-menu-item>
        <el-menu-item index="/settings/company" v-if="permissions['permissionFullAccess']">
          <i class="uil uil-sliders-v-alt text-xl pr-1"></i>
          <span>Company Details</span>
        </el-menu-item>
        <el-menu-item
          index="scheduling-rostering"
          v-if="hasSchedulingRostering"
          @click="goToSchedulingRostering"
          class="mb-0"
          data-cy="scheduling-rostering-tab"
        >
          <i class="uil uil-calendar text-xl pr-1"></i>
          <span>Scheduling & Rostering</span>
        </el-menu-item>
        <el-menu-item
          index="scheduling-rules"
          v-if="hasSchedulingRostering"
          @click="goToSchedulingRules"
          class="settings-sub-item"
          data-cy="scheduling-rules-tab"
        >
          <i class="uil uil-corner-down-right text-sm pr-1"></i>
          <span>Scheduling Rules</span>
        </el-menu-item>
        <el-menu-item
          index="shifts"
          v-if="hasSchedulingRostering"
          @click="goToShifts"
          class="settings-sub-item"
          data-cy="shifts-tab"
        >
          <i class="uil uil-corner-down-right text-sm pr-1"></i>
          <span>Shifts</span>
        </el-menu-item>
        <el-menu-item
          index="associate-requests"
          v-if="hasSchedulingRostering"
          @click="goToAssociateRequests"
          class="settings-sub-item"
          data-cy="associate-requests-tab"
        >
          <i class="uil uil-corner-down-right text-sm pr-1"></i>
          <span>Associate Requests</span>
        </el-menu-item>
        <el-menu-item index="/settings/users" v-if="permissions['permissionFullAccess']" data-cy="user-tab">
          <i class="uil uil-users-alt text-xl pr-1"></i>
          <span>Users</span>
        </el-menu-item>
        <el-menu-item v-show="permissions['permissionFullAccess'] && $route.name === 'SettingsUserDetail'" index="/settings/users/detail" class="settings-sub-item">
          <i class="uil uil-corner-down-right text-sm pr-1"></i>
          <span>User Details</span>
        </el-menu-item>
        <el-menu-item index="/settings/users/roles" v-if="permissions['permissionFullAccess']" class="settings-sub-item">
          <i class="uil uil-corner-down-right text-sm pr-1"></i>
          <span>Roles</span>
        </el-menu-item>
        <el-menu-item index="/settings/users/org-chart" v-if="permissions['permissionFullAccess']" class="settings-sub-item">
          <i class="uil uil-corner-down-right text-sm pr-1"></i>
          <span>Org Chart</span>
        </el-menu-item>
        <el-menu-item index="api-keys" v-if="permissions['permissionFullAccess']" class="settings-sub-item" @click="goToServiceUsers">
          <i class="uil uil-corner-down-right text-sm pr-1"></i>
          <span>API Keys</span>
        </el-menu-item>
        <el-menu-item index="/settings/hera-ai" v-if="permissions['permissionFullAccess'] && (featurePermissions['featureEnabledVehiclePhotoLogsHeraAi'] || featurePermissions['featureEnabledAmazonChromePlugin'] || featurePermissions['featureEnabledAIChat'])">
          <i class="uil uil-atom text-xl pr-1"></i>
          <span>Hera AI</span>
        </el-menu-item>
        <el-menu-item index="/settings/driver-feedback" v-if="permissions['permissionFullAccess']">
          <i class="uil uil-comment-alt-dots text-xl pr-1"></i>
          <span>Coaching</span>
        </el-menu-item>
        <el-menu-item index="/settings/messenger" v-if="permissions['permissionMessenger'] || permissions['permissionMessageTemplate']" data-cy="messenger-tab">
          <i class="uil uil-comment-alt-dots text-xl pr-1"></i>
          <span>Messenger</span>
        </el-menu-item>
        <el-menu-item index="/settings/drop-downs" v-if="permissions['permissionCustomLists']">
          <i class="uil uil-angle-down text-xl pr-1"></i>
          <span>Drop-Down Lists</span>
        </el-menu-item>
        <el-menu-item index="/settings/custom-lists" v-if="permissions['permissionCustomLists']" data-cy="custom-lists-tab">
          <i class="uil uil-list-ul text-xl pr-1"></i>
          <span>Custom Lists</span>
        </el-menu-item>
        <el-menu-item index="/settings/vehicle-photo-logs" v-if="permissions['permissionVehiclePhotoLogs'] || permissions['permissionFullAccess']" data-cy="vehicle-photo-logs">
          <i class="uil uil-image text-xl pr-1"></i>
          <span>Vehicle Photo Logs</span>
        </el-menu-item>
        <el-menu-item index="/settings/labels" v-if="(permissions['permissionManageLabels'] && (hasStaffManagement || hasVehicleManagement))">
          <i class="uil uil-label text-xl pr-1"></i>
          <span>Labels</span>
        </el-menu-item>
        <el-menu-item index="/settings/roster-checklists" v-if="permissions['permissionCompanySettingsRosterChecklistTemplates'] && featurePermissions['featureAccessRosterChecklist']" class="flex">
          <i class="uil uil-clipboard-notes text-xl"></i>
          <span>Roster Checklist</span>
        </el-menu-item>
        <el-menu-item
          index="phone-automation"
          v-if="isIvrEnabled && permissions['permissionFullAccess']"
          @click.native.capture.stop="goToPhoneAutomation"
          class="mb-0"
        >
          <i class="uil uil-phone-alt text-xl pr-1"></i>
          <span>Phone Automation</span>
        </el-menu-item>
        <el-menu-item
          index="phone-tree"
          v-if="isIvrEnabled && permissions['permissionFullAccess']"
          @click.native.capture.stop="goToPhoneAutomation"
          class="settings-sub-item"
        >
          <i class="uil uil-corner-down-right text-sm pr-1"></i>
          <span>Phone Tree</span>
        </el-menu-item>

        <el-menu-item index="/settings/inventory" v-if="featurePermissions['featureAccessInventoryManagement'] && permissions['permissionFullAccess']" class="flex">
          <i class="uil uil-cube text-xl"></i>
          <span>Inventory</span>
        </el-menu-item>
        <el-menu-item index="/settings/wireless-support-sync" v-if="featurePermissions['featureAccessWirelessSupportSync'] && permissions['permissionFullAccess']" class="flex">
          <i class="uil uil-mobile-android text-xl pr-1"></i>
          <span>Wireless Support Sync</span>
        </el-menu-item>
        <el-menu-item index="/settings/associate-app" class="flex" v-if="permissions['permissionFullAccess'] && featurePermissions['featureAccessAssociateApp']">
          <i class="uil uil-mobile-android text-xl"></i>
          <span>Associate App</span>
        </el-menu-item>
        <el-menu-item index="payroll-provider" v-if="permissions['permissionFullAccess'] && featurePermissions['featureAccessPayrollProvider']" @click="goToPayrollProvider" class="flex">
          <i class="uil uil-money-bill text-xl"></i>
          <span>Payroll Provider</span>
        </el-menu-item>
      </el-menu>
    </div>

      <div class="flex-1 grid grid-cols-1">
        <transition name="fade" mode="out-in">   
            <router-view name='settings' :key="$route.path"/>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex'
import ContextMenuHeaderIcon from '@/components/ContextMenuHeaderIcon';
import { getUserPermissions, getTenantFeaturePermissions } from '@/middlewares/permissions'

export default {
  components:{ ContextMenuHeaderIcon },
  data() {
    return {
      permissions: {},
      windowWidth: window.innerWidth,
      navActive: false
    }
  },
  computed:{
    ...mapGetters([
      'hasStaffManagement',
      'hasVehicleManagement',
      'isAdmin'
    ]),
    activePath(){
      var path = this.$route.path
      var subPaths = ['/settings/users/roles', '/settings/users/org-chart', '/settings/users/detail']
      if (subPaths.some(function(p) { return path.startsWith(p) })) return path
      var pathArray = path.split("/")
      var basePath = `/${pathArray[1]}/${pathArray[2]}`
      return basePath
    },
    featurePermissions(){
      return getTenantFeaturePermissions()
    },
    hasSchedulingRostering(){
      return this.permissions['permissionCompanySettingsSchedulingRostering'] && this.featurePermissions['featureAccessSchedulingAndRostering'] && this.featurePermissions['featureEnabledSchedulingAndRostering']
    },

    isIvrEnabled(){
      return this.featurePermissions['featureAccessPhoneAutomation'] && this.featurePermissions['featureEnabledPhoneAutomation']
    },

    isMobile(){
      return this.windowWidth <= 768
    }
  },

  methods: {
    onMenuSelect() {
      // Close mobile menu when item is selected
      if (this.isMobile) {
        this.navActive = false
      }
    },
    goToServiceUsers() {
      window.location.href = this.goToAthena('/settings/service-users')
    },
    goToSchedulingRostering() {
      window.location.href = this.goToAthena('/settings/scheduler/operating-hours')
    },
    goToSchedulingRules() {
      window.location.href = this.goToAthena('/settings/scheduler/scheduling-rules')
    },
    goToShifts() {
      window.location.href = this.goToAthena('/settings/scheduler/shifts')
    },
    goToAssociateRequests() {
      window.location.href = this.goToAthena('/settings/scheduler/associate-requests')
    },
    goToPayrollProvider() {
      window.location.href = this.goToAthena('/settings/payroll-provider')
    },
    goToPhoneAutomation() {
      window.location.href = this.goToAthena('/ivr')
    },
    handleResize() {
      this.windowWidth = window.innerWidth
      // Close menu when switching to desktop
      if (!this.isMobile) {
        this.navActive = false
      }
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },

  beforeMount() {
    getUserPermissions(this.$store.state.userInfo.id, this.$store.state.userInfo.tenant.group)
    .then(userPermissions => {
      this.permissions = userPermissions
    })
  },
}

</script>

<style lang="scss" scoped>
  .router-link-active{
    @apply text-brand;
  }
  .el-menu-item.is-active{
    @apply bg-gray-200;
  }
</style>

<style>
.settings-menu .el-menu-item{
    @apply p-3 mx-2 rounded-md h-auto my-2 leading-4 align-middle !important;
}
.settings-menu .el-menu-item.settings-sub-item{
    @apply ml-8 my-0 text-sm !important;
} 
.settings-menu .el-menu-item.el-menu-item.is-active{
    @apply bg-gray-200 !important;
} 
.settings-menu .el-menu-item:hover, .el-menu-item:focus {
	@apply bg-gray-200 text-black !important;
}
.settings-menu .el-menu-item:hover i{
	@apply  text-black !important;
}

.settings-toggle{
  display: none !important;
}

@media only screen and (max-width: 768px) {
  .settings-wrap h1{
    @apply relative;
  }
  .settings-toggle{
    display: block !important;
    color: #aaa;
    margin-bottom: 1em !important;
  }
  .settings-toggle > span{ 
    display: flex;
  }
  .settings-menu-wrap{
    position: absolute;
    transition: transform .2s ease, opacity .2s ease;
    top: -3.5em;
    height: auto;
    background: #fff;
    width: auto;
    transform: translate(-15rem, 0);
    opacity: 0;
    padding: 2em 2em 2em 4.5em;
    box-shadow: 1px 3px 10px rgb(0, 0, 0, .2);
    pointer-events: none;
    z-index: 20;
  }
  .settings-menu-wrap.active{
    transform: translate(-4.5rem, 0);
    opacity: 1;
    pointer-events: auto;
  }
  .settings-menu{
    border:none !important
  }
}
</style>
